// project imports
import { YONETICI, BINA_SAKINI } from 'utils/roles';

// assets
import HomeOutlined from '@ant-design/icons/HomeOutlined';
import BellOutlined from '@ant-design/icons/BellOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import ApartmentOutlined from '@ant-design/icons/ApartmentOutlined';
import AppstoreOutlined from '@ant-design/icons/AppstoreOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import DollarOutlined from '@ant-design/icons/DollarOutlined';
import WalletOutlined from '@ant-design/icons/WalletOutlined';
import AccountBookOutlined from '@ant-design/icons/AccountBookOutlined';
import GroupOutlined from '@ant-design/icons/GroupOutlined';
import NotificationOutlined from '@ant-design/icons/NotificationOutlined';
import BookOutlined from '@ant-design/icons/BookOutlined';
import InboxOutlined from '@ant-design/icons/InboxOutlined';
import DatabaseOutlined from '@ant-design/icons/DatabaseOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import CreditCardOutlined from '@ant-design/icons/CreditCardOutlined';
import BarChartOutlined from '@ant-design/icons/BarChartOutlined';
import FileSearchOutlined from '@ant-design/icons/FileSearchOutlined';
import ContainerOutlined from '@ant-design/icons/ContainerOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import CarOutlined from '@ant-design/icons/CarOutlined';
import ProfileOutlined from '@ant-design/icons/ProfileOutlined';
import MessageOutlined from '@ant-design/icons/MessageOutlined';
import SoundOutlined from '@ant-design/icons/SoundOutlined';
import SolutionOutlined from '@ant-design/icons/SolutionOutlined';
import AlertOutlined from '@ant-design/icons/AlertOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import PieChartOutlined from '@ant-design/icons/PieChartOutlined';
import FormOutlined from '@ant-design/icons/FormOutlined';
import ToolOutlined from '@ant-design/icons/ToolOutlined';
import AreaChartOutlined from '@ant-design/icons/AreaChartOutlined';

// ==============================|| MENÜ - ROL SABİTLERİ ||============================== //

const HER_IKI_ROL = [YONETICI, BINA_SAKINI];
const SADECE_YONETICI = [YONETICI];
const SADECE_SAKIN = [BINA_SAKINI];

// Site Yöneticisi'nin tanım/CRUD işlemleri Django Admin üzerinden yapılır
// (bkz. CLAUDE.md → "Admin Panel / React Arayüzü Ayrımı"); target=true olan
// menü ögeleri SPA route'u değil, ilgili Django Admin sayfasına giden dış
// linktir. NavItem bu ögelerde önce bilgilendirme modalı gösterip JWT
// üzerinden admin session'ı açar (AdminGecisModal), sonra linke geçilir.
const ADMIN_URL = '/admin/';

// ==============================|| MENÜ - TAM AĞAÇ (rol filtresiz) ||============================== //
// Navigation bileşeni bu ağacı kullaniciTipi'ne göre filtreler (bkz. menu-items/index.jsx).
// MainRoutes.jsx de route guard'ları aynı bu ağaçtan (routableItems) üretir; tek doğruluk kaynağı budur.

const menuConfig = [
  {
    id: 'group-genel',
    title: '',
    type: 'group',
    children: [
      { id: 'ana-sayfa', title: 'Ana Sayfa', type: 'item', url: '/', icon: HomeOutlined, roles: HER_IKI_ROL },
      { id: 'bildirimler', title: 'Bildirimler', type: 'item', url: '/bildirimler', icon: BellOutlined, roles: HER_IKI_ROL },
      { id: 'notlar', title: 'Notlar / Ajanda', type: 'item', url: '/notlar', icon: CalendarOutlined, roles: SADECE_YONETICI }
    ]
  },
  {
    id: 'group-hesabim',
    title: 'Hesabım',
    type: 'group',
    icon: UserOutlined,
    children: [
      { id: 'profil-bilgileri', title: 'Profil Bilgileri', type: 'item', url: '/profil', icon: UserOutlined, roles: HER_IKI_ROL },
      { id: 'odemeler', title: 'Ödemeler', type: 'item', url: '/odemeler', icon: CreditCardOutlined, roles: HER_IKI_ROL },
      {
        id: 'apartman-finansal-durum',
        title: 'Apartman Finansal Durum',
        type: 'item',
        url: '/apartman-finansal-durum',
        icon: PieChartOutlined,
        roles: HER_IKI_ROL
      }
    ]
  },
  {
    id: 'group-apartman',
    title: 'Apartman Yönetimi',
    type: 'group',
    icon: ApartmentOutlined,
    children: [
      {
        id: 'site-blok-listesi',
        title: 'Site / Blok Listesi',
        type: 'item',
        url: '/admin/sites/blok/',
        icon: ApartmentOutlined,
        roles: SADECE_YONETICI,
        target: true
      },
      {
        id: 'daire-listesi',
        title: 'Daire Listesi / Tanımlama',
        type: 'item',
        url: '/apartman/daire-listesi',
        icon: AppstoreOutlined,
        roles: HER_IKI_ROL
      },
      {
        id: 'kisi-listesi',
        title: 'Kişi Listesi / Tanımlama',
        type: 'item',
        url: '/apartman/kisi-listesi',
        icon: TeamOutlined,
        roles: HER_IKI_ROL
      }
    ]
  },
  {
    id: 'group-finans',
    title: 'Finansal İşlemler',
    type: 'group',
    icon: DollarOutlined,
    children: [
      {
        id: 'gelir-islemleri',
        title: 'Gelir İşlemleri',
        type: 'item',
        url: '/finans/gelir-islemleri',
        icon: DollarOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'gider-islemleri',
        title: 'Gider İşlemleri',
        type: 'item',
        url: '/finans/gider-islemleri',
        icon: WalletOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'tahsilat-islemleri',
        title: 'Tahsilat İşlemleri',
        type: 'item',
        url: '/finans/tahsilat-islemleri',
        icon: CreditCardOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'odeme-islemleri',
        title: 'Ödeme İşlemleri',
        type: 'item',
        url: '/finans/odeme-islemleri',
        icon: WalletOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'alacak-borc-yonetimi',
        title: 'Alacak / Borç Yönetimi',
        type: 'item',
        url: '/finans/alacak-borc-yonetimi',
        icon: AccountBookOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'aidat-islemleri',
        title: 'Aidat İşlemleri',
        type: 'item',
        url: '/finans/aidat-islemleri',
        icon: AccountBookOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'otomatik-alacak-borc',
        title: 'Otomatik Alacak/Borç Tanımlama',
        type: 'item',
        url: '/finans/otomatik-alacak-borc',
        icon: SettingOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'toplu-islemler',
        title: 'Toplu Alacak Tanımlama',
        type: 'item',
        url: '/finans/toplu-islemler',
        icon: GroupOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'sayac-islemleri',
        title: 'Sayaç İşlemleri',
        type: 'item',
        url: '/finans/sayac-islemleri',
        icon: DatabaseOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'kasalar-arasi-transfer',
        title: 'Kasalar Arası Transfer',
        type: 'item',
        url: '/finans/kasalar-arasi-transfer',
        icon: ContainerOutlined,
        roles: SADECE_YONETICI
      }
    ]
  },
  {
    id: 'group-yonetim',
    title: 'Yönetim İşlemleri',
    type: 'group',
    icon: SolutionOutlined,
    children: [
      {
        id: 'yonetim-toplu-islemler',
        title: 'Toplu İşlemler',
        type: 'item',
        url: '/yonetim/toplu-islemler',
        icon: GroupOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'butce-planlama',
        title: 'Bütçe Planlama',
        type: 'item',
        url: '/yonetim/butce-planlama',
        icon: PieChartOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'vukuat',
        title: 'Vukuat / Olay Kayıtları',
        type: 'item',
        url: '/yonetim/vukuat',
        icon: AlertOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'teklif-yonetimi',
        title: 'Teklif Yönetimi',
        type: 'item',
        url: '/yonetim/teklif-yonetimi',
        icon: SolutionOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'toplanti-yonetimi',
        title: 'Toplantı Yönetimi',
        type: 'item',
        url: '/yonetim/toplanti-yonetimi',
        icon: TeamOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'karar-defteri',
        title: 'Karar Defteri',
        type: 'item',
        url: '/yonetim/karar-defteri',
        icon: BookOutlined,
        roles: HER_IKI_ROL
      },
      {
        id: 'demirbas',
        title: 'Demirbaş Listesi / Tanımlama',
        type: 'item',
        url: '/yonetim/demirbas',
        icon: InboxOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'stok',
        title: 'Stok Listesi / Tanımla / Düzenle',
        type: 'item',
        url: '/yonetim/stok',
        icon: DatabaseOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'evrak-arsivi',
        title: 'Dosya / Evrak Arşivi',
        type: 'item',
        url: '/yonetim/evrak-arsivi',
        icon: ContainerOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'calisan-yonetimi',
        title: 'Çalışan Yönetimi',
        type: 'item',
        url: '/personel/calisan-yonetimi',
        icon: ProfileOutlined,
        roles: SADECE_YONETICI
      }
    ]
  },
  {
    id: 'group-tanimlar',
    title: '',
    type: 'group',
    children: [
      {
        id: 'tanimlar',
        title: 'Tanımlar',
        type: 'item',
        url: ADMIN_URL,
        icon: SettingOutlined,
        roles: SADECE_YONETICI,
        target: true
      }
    ]
  },
  {
    id: 'group-ayarlar',
    title: 'Ayarlar',
    type: 'group',
    icon: SettingOutlined,
    children: [
      {
        id: 'apartman-bilgileri',
        title: 'Apartman Bilgileri',
        type: 'item',
        url: '/admin/accounts/site/',
        icon: ApartmentOutlined,
        roles: SADECE_YONETICI,
        target: true
      },
      {
        id: 'gecikme-zammi-ayarlari',
        title: 'Gecikme Zammı Ayarları',
        type: 'item',
        url: '/admin/ayarlar/gecikmezammiayari/',
        icon: AlertOutlined,
        roles: SADECE_YONETICI,
        target: true
      },
      {
        id: 'online-odeme-ayarlari',
        title: 'Online Ödeme Ayarları',
        type: 'item',
        url: '/ayarlar/online-odeme-ayarlari',
        icon: CreditCardOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'banka-hareketleri-eslestirme',
        title: 'Banka Hesap Hareketleri Eşleştirme',
        type: 'item',
        url: '/ayarlar/banka-hareketleri-eslestirme',
        icon: AccountBookOutlined,
        roles: SADECE_YONETICI
      },
      {
        id: 'bildirim-ayarlari',
        title: 'Bildirim Ayarları',
        type: 'item',
        url: '/admin/ayarlar/bildirimayari/',
        icon: NotificationOutlined,
        roles: SADECE_YONETICI,
        target: true
      }
    ]
  },
  {
    id: 'group-raporlar',
    title: 'Raporlar',
    type: 'group',
    icon: AreaChartOutlined,
    children: [
      {
        id: 'raporlar-finansal-ozet',
        title: 'Finansal Özet',
        type: 'subgroup',
        icon: BarChartOutlined,
        children: [
          {
            id: 'a1-hesap-ozeti',
            title: 'Hesap Özeti',
            type: 'item',
            url: '/raporlar/a1-hesap-ozeti',
            icon: BarChartOutlined,
            roles: HER_IKI_ROL
          },
          {
            id: 'a2-gelir-gider-raporu',
            title: 'Gelir-Gider Raporu',
            type: 'item',
            url: '/raporlar/a2-gelir-gider-raporu',
            icon: AccountBookOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'a3-kasa-hareketleri-raporu',
            title: 'Kasa Hareketleri Raporu',
            type: 'item',
            url: '/raporlar/a3-kasa-hareketleri-raporu',
            icon: ContainerOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'a4-net-durum-raporu',
            title: 'Net Durum Raporu',
            type: 'item',
            url: '/raporlar/a4-net-durum-raporu',
            icon: PieChartOutlined,
            roles: SADECE_YONETICI
          }
        ]
      },
      {
        id: 'raporlar-alacak-tahsilat',
        title: 'Alacak / Tahsilat',
        type: 'subgroup',
        icon: FileSearchOutlined,
        children: [
          {
            id: 'b1-detayli-alacak-listesi',
            title: 'Detaylı Alacak Listesi',
            type: 'item',
            url: '/raporlar/b1-detayli-alacak-listesi',
            icon: FileSearchOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'b2-borclu-listesi',
            title: 'Borçlu Listesi',
            type: 'item',
            url: '/raporlar/b2-borclu-listesi',
            icon: AlertOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'b3-gecikme-faizi-raporu',
            title: 'Gecikme Faizi Raporu',
            type: 'item',
            url: '/raporlar/b3-gecikme-faizi-raporu',
            icon: CreditCardOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'b4-tahsilat-raporu',
            title: 'Tahsilat Raporu',
            type: 'item',
            url: '/raporlar/b4-tahsilat-raporu',
            icon: DollarOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'b5-donemsel-alacaklar-raporu',
            title: 'Dönemsel Alacaklar Raporu',
            type: 'item',
            url: '/raporlar/b5-donemsel-alacaklar-raporu',
            icon: CalendarOutlined,
            roles: SADECE_YONETICI
          }
        ]
      },
      {
        id: 'raporlar-borc-odeme',
        title: 'Borç / Ödeme',
        type: 'subgroup',
        icon: WalletOutlined,
        children: [
          {
            id: 'c1-detayli-borc-listesi',
            title: 'Detaylı Borç Listesi',
            type: 'item',
            url: '/raporlar/c1-detayli-borc-listesi',
            icon: WalletOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'c2-vadesi-gecen-borclar',
            title: 'Vadesi Geçen Borçlar',
            type: 'item',
            url: '/raporlar/c2-vadesi-gecen-borclar',
            icon: AlertOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'c3-cari-borc-durumu',
            title: 'Cari Borç Durumu',
            type: 'item',
            url: '/raporlar/c3-cari-borc-durumu',
            icon: SolutionOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'c4-odeme-raporu',
            title: 'Ödeme Raporu',
            type: 'item',
            url: '/raporlar/c4-odeme-raporu',
            icon: CreditCardOutlined,
            roles: SADECE_YONETICI
          }
        ]
      },
      {
        id: 'raporlar-daire-kisi-cari',
        title: 'Daire / Kişi / Cari',
        type: 'subgroup',
        icon: TeamOutlined,
        children: [
          {
            id: 'd1-daire-finansal-durumu',
            title: 'Daire Finansal Durumu',
            type: 'item',
            url: '/raporlar/d1-daire-finansal-durumu',
            icon: AppstoreOutlined,
            roles: HER_IKI_ROL
          },
          {
            id: 'd2-kisi-finansal-durumu',
            title: 'Kişi Finansal Durumu',
            type: 'item',
            url: '/raporlar/d2-kisi-finansal-durumu',
            icon: TeamOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'd3-daire-listesi',
            title: 'Daire Listesi',
            type: 'item',
            url: '/raporlar/d3-daire-listesi',
            icon: AppstoreOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'd4-kisi-listesi',
            title: 'Kişi Listesi',
            type: 'item',
            url: '/raporlar/d4-kisi-listesi',
            icon: TeamOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'd5-plaka-listesi',
            title: 'Plaka Listesi',
            type: 'item',
            url: '/raporlar/d5-plaka-listesi',
            icon: CarOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'd6-cari-firma-listesi',
            title: 'Cari Firma Listesi',
            type: 'item',
            url: '/raporlar/d6-cari-firma-listesi',
            icon: SolutionOutlined,
            roles: SADECE_YONETICI
          }
        ]
      },
      {
        id: 'raporlar-muhasebe',
        title: 'Muhasebe',
        type: 'subgroup',
        icon: BookOutlined,
        children: [
          {
            id: 'e1-defteri-kebir',
            title: 'Defteri Kebir',
            type: 'item',
            url: '/raporlar/e1-defteri-kebir',
            icon: BookOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'e2-gelir-bakiyeleri',
            title: 'Gelir Bakiyeleri',
            type: 'item',
            url: '/raporlar/e2-gelir-bakiyeleri',
            icon: AccountBookOutlined,
            roles: SADECE_YONETICI
          }
        ]
      },
      {
        id: 'raporlar-denetim-yonetim',
        title: 'Denetim / Yönetim',
        type: 'subgroup',
        icon: FileTextOutlined,
        children: [
          {
            id: 'f1-denetleme-raporu',
            title: 'Denetleme Raporu',
            type: 'item',
            url: '/raporlar/f1-denetleme-raporu',
            icon: FileTextOutlined,
            roles: SADECE_YONETICI
          },
          {
            id: 'f2-yonetim-ozet-raporu',
            title: 'Yönetim Özet Raporu',
            type: 'item',
            url: '/raporlar/f2-yonetim-ozet-raporu',
            icon: ProfileOutlined,
            roles: SADECE_YONETICI
          }
        ]
      },
      {
        id: 'raporlar-planlama',
        title: 'Planlama',
        type: 'subgroup',
        icon: PieChartOutlined,
        children: [
          {
            id: 'g1-isletme-projesi',
            title: 'İşletme Projesi',
            type: 'item',
            url: '/raporlar/g1-isletme-projesi',
            icon: PieChartOutlined,
            roles: SADECE_YONETICI
          }
        ]
      }
    ]
  },
  {
    id: 'group-iletisim',
    title: 'İletişim',
    type: 'group',
    icon: MessageOutlined,
    children: [
      { id: 'mesaj', title: 'Mesaj', type: 'item', url: '/iletisim/mesaj', icon: MessageOutlined, roles: SADECE_YONETICI },
      { id: 'duyuru', title: 'Duyuru', type: 'item', url: '/iletisim/duyuru', icon: SoundOutlined, roles: HER_IKI_ROL },
      { id: 'anket', title: 'Anket', type: 'item', url: '/iletisim/anket', icon: SolutionOutlined, roles: HER_IKI_ROL },
      { id: 'acil-durum', title: 'Acil Durum', type: 'item', url: '/iletisim/acil-durum', icon: AlertOutlined, roles: HER_IKI_ROL }
    ]
  },
  {
    id: 'group-sakin-basvuru',
    title: 'Başvurularım',
    type: 'group',
    icon: FormOutlined,
    children: [
      {
        id: 'dilek-oneri-sikayet',
        title: 'Dilek/Öneri/Şikayet',
        type: 'item',
        url: '/basvurularim/dilek-oneri-sikayet',
        icon: FormOutlined,
        roles: SADECE_SAKIN
      },
      {
        id: 'ariza-bildirimi',
        title: 'Arıza Bildirimi',
        type: 'item',
        url: '/basvurularim/ariza-bildirimi',
        icon: ToolOutlined,
        roles: SADECE_SAKIN
      }
    ]
  }
];

// route guard üretimi için: dış link (target=true → /admin/) olmayan, gerçek
// SPA path'ine sahip tüm ögelerin düz listesi (bkz. routes/MainRoutes.jsx).
// Raporlar gibi iki seviyeli gruplarda item'lar subgroup içinde iç içe olduğu
// için önce subgroup'lar kendi children'ıyla açılır (flatMap ikinci geçiş).
export const routableItems = menuConfig
  .flatMap((group) => group.children)
  .flatMap((child) => (child.type === 'subgroup' ? child.children : [child]))
  .filter((item) => !item.target);

export default menuConfig;
